var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.modalShown,
          expression: "modalShown"
        }
      ],
      staticClass: "modal save_modal",
      attrs: { id: "modal" }
    },
    [
      _c(
        "div",
        {
          class: { "modal-main": true, layoutType: _vm.layoutType },
          attrs: { id: "save-modal" }
        },
        [
          _vm.title
            ? _c("div", { class: "title-area " + _vm.titleAreaAddStyle }, [
                _c("h2", [_vm._v(_vm._s(_vm.title))])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { class: "message-area " + _vm.messageAreaAddStyle },
            _vm._l(_vm.messages, function(m, index) {
              return _c("div", { key: index }, [
                _vm._v("\n        " + _vm._s(m) + "\n      ")
              ])
            })
          ),
          _vm._v(" "),
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.saveName,
                  expression: "saveName"
                }
              ],
              staticClass: "name-field",
              attrs: { type: "text", maxlength: "64", placeholder: "" },
              domProps: { value: _vm.saveName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.saveName = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.saveName
              ? _c("label", { staticClass: "error_text" }, [
                  _vm._v(_vm._s(_vm.errors.saveName))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "button-area" }, [
            _vm.modalType !== "message"
              ? _c(
                  "button",
                  {
                    staticClass: "main_btn",
                    attrs: { type: "button" },
                    on: { click: _vm.onCancelLoc }
                  },
                  [_vm._v(_vm._s(_vm.cancelBtnLabel))]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "main_btn",
                attrs: { type: "button" },
                on: { click: _vm.onOkLoc }
              },
              [_vm._v(_vm._s(_vm.okBtnLabel))]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35d74322", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35d74322","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/components/common/DcSaveModal.vue
// module id = null
// module chunks = 